<template>
  <div class="dara-small">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'DaraSmall',
};
</script>
